import React, { useState, useContext, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Form, Button, Alert, Card } from 'react-bootstrap';
import { FaKey } from 'react-icons/fa';
import AuthContext from '../../context/AuthContext';

const VerifyOtp = () => {
  const [otp, setOtp] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('danger');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(60);

  const { verifyOtp, resendOtp, error, clearError } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const { email, phone, phoneCode } = location.state || {};

  useEffect(() => {
    if (!email && !phone) {
      navigate('/register');
    }
    if (error) {
      setAlertMessage(error);
      clearError();
    }
  }, [email, phone, navigate, error, clearError]);

  useEffect(() => {
    let timer;
    if (resendDisabled && countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    } else if (countdown === 0) {
      setResendDisabled(false);
      setCountdown(60);
    }
    return () => clearTimeout(timer);
  }, [resendDisabled, countdown]);

  const onSubmit = async e => {
    e.preventDefault();
    if (!otp.trim() || otp.length !== 6) {
      setAlertMessage('Please enter a valid 6-digit OTP.');
      return;
    }
    setIsSubmitting(true);
    setAlertMessage('');

    const result = await verifyOtp({ email, phone, phoneCode, otp });
    setIsSubmitting(false);

    if (result?.success) {
      setAlertVariant('success');
      setAlertMessage('OTP verified successfully! Redirecting to login...');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } else {
      setAlertVariant('danger');
      setAlertMessage(result?.error || 'Invalid or expired OTP. Please try again.');
    }
  };

  const handleResend = async () => {
    setResendDisabled(true);
    setAlertMessage('');
    const result = await resendOtp({ email, phone, phoneCode });
    if (result && result.success) {
      setAlertMessage('A new OTP has been sent.');
    } else {
      setAlertMessage(result.error || 'Failed to resend OTP.');
      setResendDisabled(false);
    }
  };

  return (
    <div className="auth-container">
      <Card>
        <Card.Body>
          <h2 className="text-center mb-4">
            <FaKey className="me-2" />
            Verify OTP
          </h2>
          <p className="text-center text-muted">An OTP has been sent to your email and phone.</p>
          
          {alertMessage && (
            <Alert variant={alertVariant} onClose={() => setAlertMessage('')} dismissible>
              {alertMessage}
            </Alert>
          )}
          
          <Form onSubmit={onSubmit}>
            <Form.Group className="mb-3" controlId="otp">
              <Form.Label>Enter OTP</Form.Label>
              <Form.Control
                type="text"
                name="otp"
                value={otp}
                onChange={e => setOtp(e.target.value)}
                placeholder="Enter the 6-digit code"
                maxLength="6"
              />
            </Form.Group>
            
            <Button 
              variant="primary" 
              type="submit" 
              className="w-100 mt-3" 
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Verifying...' : 'Verify'}
            </Button>
          </Form>
          
          <div className="text-center mt-3">
            <Button 
              variant="link" 
              onClick={handleResend} 
              disabled={resendDisabled}
            >
              {resendDisabled ? `Resend OTP in ${countdown}s` : 'Resend OTP'}
            </Button>
          </div>

          <div className="text-center mt-3">
            <Link to="/login">Back to Login</Link>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default VerifyOtp;
